import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import dayjs from 'dayjs';

const PrintInventoryInfo = forwardRef((props, ref) => {
  const { countSheetData } = props;
  const userClaims = localStorage.getItem('UserClaims');
  let pdfExportComponent;

  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const pageTemplate = (props) => {
    return (
      <>
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            fontSize: "18px",
            width: '100%',
            textAlign: 'center'
          }}
        >
          Page {props.pageNum} of {props.totalPages}
        </div>
      </>
    )
  };

  const handlePrint = () => {
    if (pdfExportComponent && countSheetData.length > 0) {
      pdfExportComponent.save();
    }
  };

  useImperativeHandle(ref, () => ({
    handlePrint
  }));

  return (
    <>
      <PDFExport
        paperSize="A4"
        landscape={false}
        margin="1mm"
        scale={0.56}
        ref={(pdfExport) => (pdfExportComponent = pdfExport)}
        pageTemplate={pageTemplate}
        fileName={`${props.CountSheetName} (${props.InventoryDate})`}
        repeatHeaders={true}
      >
        <section className="form-section">
          <div style={{ justifyContent: "center" }}>
            <div>
              <div className="banner">
                <img style={{ width: "100%" }} src="./items.png" />
                <div className="banner-content">
                  <h4> {JSON.parse(userClaims)?.restaurent_name}</h4>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      marginTop: "10px",
                    }}
                  >
                    <h4>Inventory Date:</h4>
                    <h4>
                      {props.InventoryDate}
                    </h4>
                  </div>
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <h4>{props.CountSheetName}</h4>
                    <span style={{ color: "#a8a8a8" }}>|</span>
                    <h4>
                      Printed:{" "}
                      <span style={{ fontSize: "20px" }}>
                        {dayjs().format('MM/DD/YYYY hh:mmA')}
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="form-container">
                <div className="form-body">
                  {countSheetData.map(item => (
                    <>
                      <div style={{ borderBottom: "1px solid #000" }}>
                        <h5 style={{ fontSize: "28px" }}>
                          {item.CatName}
                        </h5>
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        {item?.GroupedItems.map(
                          (groupItem) => (
                            <>
                              <h4 style={{ fontSize: "20px" }}>
                                {groupItem?.SubCatName}
                              </h4>

                              {groupItem.productList.map((product) => (
                                <div class="print-table-container print-table-container2" style={{ marginBottom: '15px' }}>
                                  <table>
                                    <thead>
                                      <tr>
                                        <th>{product.Product}</th>
                                        <th>Report by</th>
                                        <th>Price</th>
                                        {/* <th>Prev Count</th>
                                        <th>Prev Amount</th> */}
                                        <th>Count</th>
                                        <th>Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {product.subproductlist.map((subproduct) =>
                                        <tr key={subproduct.subProductId}>
                                          <td>{subproduct.SubProduct}</td>
                                          <td>{subproduct.subProductUnit ?? ''}</td>
                                          <td>
                                            ${subproduct.subProductPrice
                                              ? parseFloat(subproduct.subProductPrice).toFixed(2)
                                              : "0.00"
                                            }
                                          </td>
                                          {/* <td>{subproduct.PreCount ?? 0}</td>
                                          <td>
                                            {!!subproduct.PreAmount
                                              ? currencyFormatter.format(subproduct.PreAmount)
                                              : '$0.00'
                                            }
                                          </td> */}
                                          <td>{subproduct.Count ?? 0}</td>
                                          <td>
                                            {!!subproduct.Amount
                                              ? currencyFormatter.format(subproduct.Amount)
                                              : '$0.00'
                                            }
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              ))}
                            </>
                          )
                        )}
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </PDFExport>
    </>
  );
});

export default PrintInventoryInfo;
